export default {
	parse: function (spec, dimension) {
		var result = {
			star_map: {
				width: 0,
				height: 0,
				top: 0,
				left: 0,
				line: 0,
				scale: 1,
				star_name_font_size: 1,
				constellation_name_font_size: 1,
				planet_name_font_size: 1,
			},
			star_map_border: {},
			border: {
				top: 0,
				left: 0,
				width: 0,
				height: 0,
				line: 0,
			},
			text_detail: {
				width: 0,
				height: 0,
				font_size: 0,
				font_weight: 0,
				text_align: 0,
				text_base_line: 0,
				max_text_lines: 0,
				vertical_align: 0,
				font_family: '',
				top: '',
			},
			text_saying: {
				width: 0,
				height: 0,
				font_size: 0,
				font_weight: 0,
				text_align: 0,
				text_base_line: 0,
				max_text_lines: 0,
				vertical_align: 0,
				font_family: '',
				top: '',
			},

			frame: {
				width: 0,
				height: 0
			},
			background_gradient: {
				x_modifier: 0,
				y_modifier: 0,
				width_modifier: 0,
				height_modifier: 0,
			}
		};
		if (dimension && spec) {
			var h1Percent = dimension.height / 100;
			var w1Percent = dimension.width / 100;


			result.frame = {
				width: 100 + (28 / (spec.poster_width * 10 / 100)),
				height: 100 + (28 / (spec.poster_height * 10 / 100))
			}

			var onePercentMap = window.nse_config.star_width / 100;

			result.star_map = {
				width: spec.star_map.width_modifier,
				height: spec.star_map.height_modifier,
				top: spec.star_map.y_modifier,
				left: spec.star_map.x_modifier,
				line: spec.star_map.border_width_modifier,
				star_map_projection: spec.star_map.star_map_projection,
				star_size_modifier: onePercentMap * spec.star_map.stars_size_modifier,
				constellation_line_style_width_modifier: onePercentMap * spec.star_map.constellation_linestyle_width_modifier,
				line_graticule_width_modifier: onePercentMap * spec.star_map.lines_graticule_width_modifier,
				scale: spec.scale,
				transparent_background: spec.star_map.transparent_background,
				star_name_font_size: onePercentMap,
				constellation_name_font_size: onePercentMap,
				planet_name_font_size: onePercentMap,
			}
			if(spec.star_map_border) {
				result.star_map_border = {
					width: spec.star_map_border.width_modifier,
					height: spec.star_map_border.height_modifier,
					top: spec.star_map_border.y_modifier,
					left: spec.star_map_border.x_modifier,
				}
			}

			if(spec.star_map_shape) {
				result.star_map_shape = {
					width: spec.star_map_shape.width_modifier,
					height: spec.star_map_shape.height_modifier,
					top: spec.star_map_shape.y_modifier,
					left: spec.star_map_shape.x_modifier,
				}
			}

			if (spec.border) {
				result.border = {
					top: spec.border.y_modifier,
					left: spec.border.x_modifier,
					width: spec.border.width_modifier,
					height: spec.border.height_modifier,
					line:  w1Percent * spec.border.line_width_modifier,
				}
			}

			if (spec.text_details) {
				var hd = spec.text_details.font_size_modifier * spec.text_details.max_text_lines
				result.text_detail = {
					width: 0,
					height: hd,
					top: spec.text_details.y_modifier,
					left: 0,
					font_size: h1Percent * spec.text_details.font_size_modifier,
					font_weight: spec.text_details.font_weight,
					text_align: spec.text_details.text_align,
					text_base_line: spec.text_details.text_base_line,
					max_text_lines: spec.text_details.max_text_lines,
					vertical_align: spec.text_details.vertical_align,
					font_family: '',
					line_height: spec.text_details.line_height_modifier ? spec.text_details.line_height_modifier * h1Percent : ''
				}
			}

			if (spec.text_saying) {
				var hs = spec.text_saying.line_height_modifier * spec.text_saying.max_text_lines

				result.text_saying = {
					width: 0,
					height: hs,
					top: spec.text_saying.y_modifier,
					left: 0,
					font_size: h1Percent * spec.text_saying.font_size_modifier,
					font_weight: spec.text_saying.font_weight,
					text_align: spec.text_saying.text_align,
					text_base_line: spec.text_saying.text_base_line,
					max_text_lines: spec.text_saying.max_text_lines,
					vertical_align: spec.text_saying.vertical_align,
					font_family: '',
					line_height: spec.text_saying.line_height_modifier ? spec.text_saying.line_height_modifier * h1Percent : '',
				}
			}

			if (spec.text_city) {
				var hCity = spec.text_city.font_size_modifier * spec.text_city.max_text_lines
				result.text_city = {
					width: 0,
					height: hCity,
					top: spec.text_city.y_modifier,
					left: 0,
					font_size: h1Percent * spec.text_city.font_size_modifier,
					font_weight: spec.text_city.font_weight,
					text_align: spec.text_city.text_align,
					text_base_line: spec.text_city.text_base_line,
					max_text_lines: spec.text_city.max_text_lines,
					vertical_align: spec.text_city.vertical_align,
					font_family: '',
					line_height: spec.text_city.line_height_modifier ? spec.text_city.line_height_modifier * h1Percent : ''
				}
			}

			if (spec.text_country) {
				var hCountry = spec.text_country.font_size_modifier * spec.text_country.max_text_lines
				result.text_country = {
					width: 0,
					height: hCountry,
					top: spec.text_country.y_modifier,
					left: 0,
					font_size: h1Percent * spec.text_country.font_size_modifier,
					font_weight: spec.text_country.font_weight,
					text_align: spec.text_country.text_align,
					text_base_line: spec.text_country.text_base_line,
					max_text_lines: spec.text_country.max_text_lines,
					vertical_align: spec.text_country.vertical_align,
					font_family: '',
					line_height: spec.text_country.line_height_modifier ? spec.text_country.line_height_modifier * h1Percent : ''
				}
			}

			if (spec.background_gradient) {
				result.background_gradient = {
					x_modifier: spec.background_gradient.x_modifier,
					y_modifier: spec.background_gradient.y_modifier,
					width_modifier: spec.background_gradient.width_modifier,
					height_modifier: spec.background_gradient.height_modifier,
					x1: spec.background_gradient.x1,
					x2: spec.background_gradient.x2,
					y1: spec.background_gradient.y1,
					y2: spec.background_gradient.y2,
				}
			}

			if (spec.background) {
				result.background = {
					left: spec.background.x_modifier,
					top: spec.background.y_modifier,
					width: spec.background.width_modifier,
					height: spec.background.height_modifier,
				}
			} else{
				result.background = {
					left: 0,
					top: 0,
					width: 100,
					height: 100,
				}
			}
		}

		return result;
	}
}
